import { api } from "./api";

export const currenciesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCurrencies: builder.query({
      query: () => "api/Fin/Currs",
      providesTags: ["currencies"],
    }),
    addCurrency: builder.mutation({
      query: (formData) => ({
        url: "api/Fin/Currs",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["currencies"],
    }),
    editCurrency: builder.mutation({
      query: (formData) => ({
        url: "api/Fin/Currs",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["currencies"],
    }),
    deleteCurrency: builder.mutation({
      query: (currencyId) => ({
        url: `api/Fin/Currs?CurrID=${currencyId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["currencies"],
    }),
  }),
});

export const {
  useGetCurrenciesQuery,
  useAddCurrencyMutation,
  useEditCurrencyMutation,
  useDeleteCurrencyMutation,
} = currenciesApi;
